import React, { FunctionComponent, useMemo } from "react";
import TraitSalesContext, {
  TraitSalesContextValue,
} from "contexts/TraitSalesContext";
import useFetchTraitSales from "hooks/useFetchTraitSales";

type TraitSalesProviderProps = {};

const TraitSalesProvider: FunctionComponent<TraitSalesProviderProps> = ({
  children,
}) => {
  const [traitSales] = useFetchTraitSales();

  const traitSalesMap = useMemo(
    () =>
      traitSales?.reduce(
        (prev, sale) => ({
          ...prev,
          [sale.tokenId]: sale,
        }),
        {}
      ),
    [traitSales]
  );

  const contextValue = useMemo<TraitSalesContextValue>(
    () => ({
      traitSales: traitSales || [],
      traitSalesMap: traitSalesMap || {},
    }),
    [traitSales, traitSalesMap]
  );

  return (
    <TraitSalesContext.Provider value={contextValue}>
      {children}
    </TraitSalesContext.Provider>
  );
};

export default TraitSalesProvider;
